import { ReactNode } from 'react';
import { Typography } from '@weareopenr/component-library';
import styles from './SummaryLines.module.scss';
import { ISummaryLine } from './summary';

interface ISummaryLinesProps {
  lines: ISummaryLine[];
  children?: ReactNode;
}

const SummaryLines = ({ lines, children }: ISummaryLinesProps) => (
  <ul className={styles['summary-lines']}>
    {lines.map((line) => (
      <li key={line.collection}>
        <Typography size="small">
          <strong>{line.label}</strong> — {line.actionsText}
        </Typography>
      </li>
    ))}
    {children}
  </ul>
);

export default SummaryLines;
